export default "__VITE_ASSET__Dw_qQa1T__"